import { useState } from "react";
import { useT } from "../../../lib/use-t";
import { getVocabLibrary } from "../../../data/vocab/library";
import { SuperZinnenCard } from "../../../components/woorden/SuperZinnenCard";
import { TopicGrid } from "../../../components/woorden/TopicGrid";

export function WoordenIndexPage() {
  const t = useT();
  const [query, setQuery] = useState("");
  const total = getVocabLibrary().stats.total;

  return (
    <div className="mx-auto w-full max-w-[1100px] px-5 sm:px-6 py-6 sm:py-8 space-y-8">
      <header className="space-y-2">
        <p className="font-mono-badge text-xs uppercase tracking-wider text-[var(--ink-faint)]">
          {t("woorden.eyebrow")}
        </p>
        <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight">
          {t("woorden.topicsTitle")}
        </h1>
        <p className="text-[var(--ink-muted)] max-w-prose">{t("woorden.topicsLead")}</p>
      </header>

      <div className="flex flex-wrap items-center gap-3">
        <label className="flex flex-1 max-w-[340px] items-center gap-2.5 rounded-full border border-[var(--border-strong)] bg-[var(--panel-soft)] px-4 py-2.5 text-[var(--ink-faint)] focus-within:border-[var(--accent)]">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden
          >
            <circle cx="11" cy="11" r="7" />
            <path d="M21 21l-4-4" />
          </svg>
          <input
            type="search"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={t("woorden.searchPlaceholder")}
            aria-label={t("woorden.searchPlaceholder")}
            className="w-full bg-transparent text-sm text-[var(--ink)] outline-none placeholder:text-[var(--ink-faint)]"
          />
        </label>
        <span className="ml-auto font-mono-badge text-xs text-[var(--ink-faint)] tabular-nums">
          {t("woorden.totalFmt", { count: total })}
        </span>
      </div>

      <SuperZinnenCard />
      <TopicGrid query={query} />
    </div>
  );
}
